import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { GlobalService } from './global.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
    private afAuth: AngularFireAuth,
    private router: Router,
    public _globalService: GlobalService
  ) {}


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

      return this.afAuth.authState
       .map(user => user ? user.emailVerified : false)
       .do(emailVerified => {
        //  console.log('guaaaaaaaaarddddddd ', emailVerified);
         if (!emailVerified) {
          //  console.log('access denied');
           this.router.navigate(['/']);
         }
     });
   }

}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts